export default {
  // API_ENDPOINT: "http://localhost:8000",
  API_ENDPOINT: "https://blooming-dusk-61274.herokuapp.com",
  TOKEN_KEY: "art-client-auth-token"
};
